(function () {
  function initPriceUpdate() {
    const priceElement = document.querySelector('[id^="custom-price-"]');

    if (!priceElement) {
      setTimeout(initPriceUpdate, 500);
      return;
    }

    const sectionId = priceElement.id.replace('custom-price-', '');
    const dataElement = document.getElementById('variant-data-' + sectionId);
    if (!dataElement) return;

    const variantData = JSON.parse(dataElement.textContent);
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    let lastVariantId = null;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function getAddonPrice() {
      let totalAddonPrice = 0;
      document
        .querySelectorAll('.wc-pao-addon-container input[type="radio"]:checked')
        .forEach((addon) => {
          totalAddonPrice += parseInt(addon.dataset.price || 0);
        });
      return totalAddonPrice;
    }

    // NEW: read current quantity from the input
    function getQuantity() {
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (!qtyInput) return 1;
      const qty = parseInt(qtyInput.value);
      return qty > 0 ? qty : 1;
    }

    function updatePrice() {
      const variantId = parseInt(variantInput.value);
      if (!variantId) return;

      const variant = variantData.variants.find((v) => v.id === variantId);
      if (!variant) return;

      const quantity = getQuantity();                      // NEW
      let totalPrice = (variant.price + getAddonPrice()) * quantity;  // NEW

      priceElement.textContent = formatMoney(totalPrice);
    }

    // Watch variant changes
    setInterval(() => {
      const currentId = parseInt(variantInput.value);
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        updatePrice();
      }
    }, 50);

    // NEW: watch quantity input changes
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[name="quantity"]')) {
        updatePrice();
      }
    });

    // NEW: also catch +/- button clicks (they update value but may not fire 'change')
    document.addEventListener('click', function (e) {
      if (e.target.closest('.quantity-minus, .quantity-plus')) {
        setTimeout(updatePrice, 0); // slight defer so input value is already updated
      }
    });

    document.addEventListener('addon:update', updatePrice);

    document.addEventListener('change', function (e) {
      if (e.target.matches('.wc-pao-addon-container input[type="radio"]')) {
        updatePrice();
      }
    });

    updatePrice();
    setTimeout(updatePrice, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceUpdate);
  } else {
    initPriceUpdate();
  }
})();